import React, { useState, useEffect } from 'react';
import './GestionStages.css';
import DashboardHeader from '../../components/DashboardHeader';
import AdminNavigationBar from '../../components/AdminNavigationBar';
import { EditIcon, DeleteIcon } from '../../components/Icons';

function GestionStages() {
  const [stages, setStages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({
    titre: '',
    entreprise: '',
    description: '',
    duree: '',
    date_debut: '',
    date_fin: '',
    lieu: '',
    contact: '',
    email: ''
  });
  const [editingId, setEditingId] = useState(null);

  useEffect(() => {
    fetchStages();
  }, []);

  const fetchStages = async () => {
    try {
      setLoading(true);
      const response = await fetch('http://127.0.0.1:8000/api/v1/admin/opportunites');
      const data = await response.json();
      // Filtrer uniquement les stages (type = 'stage')
      const allOpportunites = data.data || data || [];
      const stagesOnly = allOpportunites.filter(opp => opp.type === 'stage');
      setStages(stagesOnly);
      setLoading(false);
    } catch (error) {
      console.error('Erreur lors du chargement des stages:', error);
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const url = editingId 
        ? `http://127.0.0.1:8000/api/v1/admin/opportunites/${editingId}`
        : 'http://127.0.0.1:8000/api/v1/admin/opportunites';
      
      // Ajouter le type 'stage' aux données
      const dataToSend = {
        ...formData,
        type: 'stage',
        organisme: formData.entreprise, // Mapper entreprise vers organisme
        contenu: formData.description // Mapper description vers contenu
      };

      // Pour les mises à jour, utiliser POST avec _method
      const method = editingId ? 'POST' : 'POST';
      if (editingId) {
        dataToSend._method = 'PUT';
      }
      
      const response = await fetch(url, {
        method: method,
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(dataToSend)
      });

      const responseData = await response.json();

      if (response.ok) {
        alert(editingId ? 'Stage modifié avec succès' : 'Stage créé avec succès');
        fetchStages();
        setFormData({
          titre: '',
          entreprise: '',
          description: '',
          duree: '',
          date_debut: '',
          date_fin: '',
          lieu: '',
          contact: '',
          email: ''
        });
        setShowForm(false);
        setEditingId(null);
      } else {
        console.error('Erreur réponse:', responseData);
        alert(`Erreur lors de l'enregistrement: ${responseData.message || 'Erreur inconnue'}`);
      }
    } catch (error) {
      console.error('Erreur complète:', error);
      alert(`Erreur lors de la sauvegarde: ${error.message}`);
    }
  };

  const handleEdit = (stage) => {
    setFormData({
      titre: stage.titre || '',
      entreprise: stage.organisme || '',
      description: stage.contenu || stage.description || '',
      duree: stage.duree || '',
      date_debut: stage.date_debut || '',
      date_fin: stage.date_fin || stage.date_limite || '',
      lieu: stage.ville || stage.lieu || '',
      contact: stage.contact || '',
      email: stage.email || ''
    });
    setEditingId(stage.id);
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm('Êtes-vous sûr de vouloir supprimer ce stage?')) {
      try {
        await fetch(`http://127.0.0.1:8000/api/v1/admin/opportunites/${id}`, {
          method: 'DELETE'
        });
        fetchStages();
      } catch (error) {
        console.error('Erreur lors de la suppression:', error);
      }
    }
  };

  if (loading) {
    return (
      <div className="admin-layout">
        <DashboardHeader />
        <AdminNavigationBar 
          title="Gestion des Stages" 
          onBack={() => window.navigateTo && window.navigateTo('admin-dashboard')}
        />
        <div className="admin-container">
          <main className="admin-content admin-content-full">
            <div className="loading-state">Chargement...</div>
          </main>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-layout">
      <DashboardHeader />
      <AdminNavigationBar 
        title="Gestion des Stages" 
        onBack={() => window.navigateTo && window.navigateTo('admin-dashboard')}
      />
      <div className="admin-container">
        <main className="admin-content admin-content-full">
          <div className="gestion-header">
            <button 
              className="btn btn-primary"
              onClick={() => {
                setShowForm(!showForm);
                setEditingId(null);
                setFormData({
                  titre: '',
                  entreprise: '',
                  description: '',
                  duree: '',
                  date_debut: '',
                  date_fin: '',
                  lieu: '',
                  contact: '',
                  email: ''
                });
              }}
            >
              {showForm ? 'Annuler' : 'Ajouter un Stage'}
            </button>
          </div>

          {showForm && (
            <div className="form-card">
              <h2>{editingId ? 'Modifier le Stage' : 'Ajouter un Nouveau Stage'}</h2>
              <form onSubmit={handleSubmit} className="gestion-form">
                <div className="form-row">
                  <input
                    type="text"
                    name="titre"
                    placeholder="Titre du stage"
                    value={formData.titre}
                    onChange={handleChange}
                    required
                  />
                  <input
                    type="text"
                    name="entreprise"
                    placeholder="Entreprise"
                    value={formData.entreprise}
                    onChange={handleChange}
                    required
                  />
                </div>

                <textarea
                  name="description"
                  placeholder="Description du stage"
                  value={formData.description}
                  onChange={handleChange}
                  rows="4"
                  required
                ></textarea>

                <div className="form-row">
                  <input
                    type="text"
                    name="duree"
                    placeholder="Durée (ex: 3 mois)"
                    value={formData.duree}
                    onChange={handleChange}
                  />
                  <input
                    type="text"
                    name="lieu"
                    placeholder="Lieu"
                    value={formData.lieu}
                    onChange={handleChange}
                  />
                </div>

                <div className="form-row">
                  <input
                    type="date"
                    name="date_debut"
                    value={formData.date_debut}
                    onChange={handleChange}
                  />
                  <input
                    type="date"
                    name="date_fin"
                    value={formData.date_fin}
                    onChange={handleChange}
                  />
                </div>

                <div className="form-row">
                  <input
                    type="text"
                    name="contact"
                    placeholder="Contact"
                    value={formData.contact}
                    onChange={handleChange}
                  />
                  <input
                    type="email"
                    name="email"
                    placeholder="Email"
                    value={formData.email}
                    onChange={handleChange}
                  />
                </div>

                <button type="submit" className="btn btn-primary">
                  {editingId ? 'Modifier' : 'Ajouter'}
                </button>
              </form>
            </div>
          )}

          <div className="table-card">
            <table className="data-table">
              <thead>
                <tr>
                  <th>Titre</th>
                  <th>Entreprise</th>
                  <th>Lieu</th>
                  <th>Durée</th>
                  <th>Date Début</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {stages.map((stage) => (
                  <tr key={stage.id}>
                    <td>{stage.titre}</td>
                    <td>{stage.entreprise}</td>
                    <td>{stage.lieu}</td>
                    <td>{stage.duree}</td>
                    <td>{stage.date_debut}</td>
                    <td className="action-buttons">
                      <button 
                        className="action-btn edit-btn"
                        onClick={() => handleEdit(stage)}
                        title="Modifier"
                      >
                        <EditIcon size={16} />
                      </button>
                      <button 
                        className="action-btn delete-btn"
                        onClick={() => handleDelete(stage.id)}
                        title="Supprimer"
                      >
                        <DeleteIcon size={16} />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </main>
      </div>
    </div>
  );
}

export default GestionStages;
